document.addEventListener('DOMContentLoaded', function() {
  var screenWidth = window.innerWidth;

  if (screenWidth > 768) { // Adjust this breakpoint as needed
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = '//js-na1.hs-scripts.com/24088245.js'; // Use the URL provided by HubSpot
    document.body.appendChild(script);
  }
});
